import Flx from "../../layout/Flx";
import InfoItemLabel from "./InfoItemLabel";
import InfoItemValue from "./InfoItemValue";

const InfoRowItem = ({
  label,
  value,
  fontSize,
  labelFontSize = "12px",
  valueFontSize = "0.95em",
  gap = 1,
  column,
  ellipsis = true,
  suppressAutoMobile = false,
}) => {
  return (
    <Flx
      wrap={!ellipsis}
      column={column}
      fw
      jb
      ac={column ? false : true}
      g={column ? 0 : gap}
      sx={ellipsis ? { overflow: "hidden" } : undefined}
      suppressAutoMobile={suppressAutoMobile}
    >
      <InfoItemLabel
        fontSize={fontSize || labelFontSize}
        sx={ellipsis ? { flexShrink: 0 } : undefined}
      >
        {label}
      </InfoItemLabel>
      <InfoItemValue
        ellipsis={ellipsis}
        fontSize={fontSize || valueFontSize}
        sx={ellipsis ? { minWidth: 0 } : undefined}
      >
        {value || "N/A"}
      </InfoItemValue>
    </Flx>
  );
};
export default InfoRowItem;
